import { DataSetStatus, ReportingSetDefinition } from "./reporting-sets.models";
import { TimeFormat, ComparisonType, AggregationType, MetricTypes } from './mongo-enums.model';
import { CalculationCondition } from 'src/shared/services/pipeline-configuration-service-base';

export interface FilterValue {
    EvalField: string;
    CompValues: any[];
    ComparisonType: ComparisonType;
    Negated: boolean;
    IsDate?: boolean;
}

export interface MetricComponent {
    IsTime: boolean;
    IsCount: boolean;
    IsPositive: boolean;
    ReportingSetName: string;
    ReportingSetGroup: string;
    StartDate?: string;
    EndDate?: string;
    DataValue?: string;
    FilterFields: FilterValue[];
    AttributeFields: FilterValue[];
    DateFields?: string[];
}

export interface MetricDefinition {
    _id: string;
    Abreviation: string; // typo is on C# file
    Active: boolean;
    AggregationType: AggregationType;
    AssignAll: boolean;
    AssignmentIDs: number[];
    AvgByDay: boolean;
    CalculatedFormula?: string;
    CompanyID: number;
    Components: MetricComponent[];
    Direction: number;
    Divisor: number;
    DoubleMultiplier?: number;
    DoubleMultiplierPrecisionMask?: number;
    EmpLevelMin: number | null;
    Group: string;
    IsEditable: boolean;
    IsTemplate: boolean;
    IsViewable: boolean;
    LastModified: string | Date;
    Level: number;
    MetricDescription: string;
    MetricDivisor: number;
    MetricID: number;
    MetricImageID: number;
    MetricName: string;
    NumericType: number;
    NumericTypeName: string;
    QueuedOnImport: boolean;
    RecLevelMin: number | null;
    ShowInSelector: boolean;
    SpecialFunction?: string;
    StandardDefinitionID: number;
    StandardDefinitionVersion?: string | Date;
    Status: DataSetStatus;
    TimeFormat: TimeFormat;
    CurrencyFormat: string;
    Type: MetricTypes;
    UseNewIds?: string | Date;
}

export interface MetricImage {
    ImageID: number,
    ImagePath: string,
}

export const enum MetricValue {
    DataField = 0,
    Time = 1,
    Count = 2,
}

export class MetricComponentModel {
    attributeFields: FilterValue[] = [];
    calculationCondition: CalculationCondition = CalculationCondition.Add;
    dataValue: string;
    endDate: string;
    filterFields: FilterValue[] = [];
    metricDate: string;
    metricType: MetricTypes;
    metricValue: MetricValue = MetricValue.DataField;
    reportingSet: ReportingSetDefinition;

    // Used for the MetricComponentPreview.  MetricComponentModal instead uses the reportingSet object.
    reportingSetName: string;
    reportingSetGroup: string;

    constructor(metricComponent?: MetricComponent, metricType?: MetricTypes) {
        this.metricType = metricType ?? MetricTypes.Standard;

        if (metricType != MetricTypes.RealTime)
            this.metricDate = metricComponent?.StartDate;

        // Set the Metric Value radio button and related fields
        if (metricComponent?.IsCount) {
            this.metricValue = MetricValue.Count;
            // No other date fields for Count.
        } else if (metricType != MetricTypes.RealTime && metricComponent?.IsTime) {
            this.metricValue = MetricValue.Time;
            this.endDate = metricComponent?.EndDate;
        } else {
            this.metricValue = MetricValue.DataField;
            this.dataValue = metricComponent?.DataValue;
        }

        // Set the "Calculation Condition"
        // Default to "Add" when missing
        if (metricComponent?.IsPositive === false) {
            this.calculationCondition = CalculationCondition.Subtract;
        } else {
            this.calculationCondition = CalculationCondition.Add;
        }

        // Deep copies of the *Fields arrays
        if (metricComponent?.FilterFields)
            this.filterFields = JSON.parse(JSON.stringify(metricComponent.FilterFields));
        if (metricComponent?.AttributeFields)
            this.attributeFields = JSON.parse(JSON.stringify(metricComponent.AttributeFields));

        this.reportingSetGroup = metricComponent?.ReportingSetGroup;
        this.reportingSetName = metricComponent?.ReportingSetName;
    }
}

export enum NumericType {
    Currency = 0,
    Number = 1,
    Percent = 2,
    Time = 3,
}
